import { useFormContext } from "react-hook-form";
import useEvent from "react-use-event-hook";

import {
  DropdownDataTransformationsFnsEnum,
  IDropdownItem,
  Log,
} from "@ryde/shared";

import { useDropdownsTransformationMap } from "./dropdown-transformation-map";

interface IUseDropdownCustomTransformation {
  controlName: string;
  dropdownItems?: IDropdownItem[];
  dropdownDataTransformationFn?: DropdownDataTransformationsFnsEnum;
}

export const useDropdownCustomTransformation = () => {
  const { dropdownsTransformationsMap } = useDropdownsTransformationMap();
  const { getValues } = useFormContext();

  const getTransformedDropdownItems = useEvent(
    ({
      controlName,
      dropdownItems,
      dropdownDataTransformationFn,
    }: IUseDropdownCustomTransformation): IDropdownItem[] => {
      if (!dropdownDataTransformationFn) {
        return dropdownItems ?? [];
      }

      const formValues = getValues();

      const transformationFn =
        dropdownsTransformationsMap[dropdownDataTransformationFn];

      if (!transformationFn) {
        Log.warn(
          `dropdown items transformationFn ${dropdownDataTransformationFn} not found`,
        );
        return dropdownItems ?? [];
      }

      Log.log(
        `dropdown items transformationFn ${dropdownDataTransformationFn} was found, with transformer name: ${transformationFn.name}`,
      );

      const transformedDropdownItems = transformationFn({
        controlName,
        formValues,
        dropdownItems,
      });

      if (Array.isArray(transformedDropdownItems)) {
        return transformedDropdownItems;
      }

      return dropdownItems ?? [];
    },
  );

  return { getTransformedDropdownItems };
};
